<div
  class="chip {{ iconStyle }} flex flex-row gap-[10px] justify-start items-center"
  [class.active]="active"
>
  <mat-icon *ngIf="icon">{{ icon }}</mat-icon>
  <span><ng-content></ng-content></span>
  <span class="count" *ngIf="count">{{ count }}</span>
</div>
